import { supabase } from '../config/supabase';

export interface SetAcceptingTasksResult {
  ok: boolean;
  accepting_tasks: boolean;
  driver_id: string;
  vehicle_id: string | null;
  at?: string;
}

export async function setAcceptingTasks(params: {
  accept: boolean;
  vehicleId?: string | null;
  lat?: number | null;
  lng?: number | null;
}): Promise<SetAcceptingTasksResult> {
  const { data, error } = await supabase.rpc('set_accepting_tasks', {
    p_accept: params.accept,
    p_vehicle_id: params.vehicleId ?? null,
    p_lat: params.lat ?? null,
    p_lng: params.lng ?? null,
  });
  if (error) throw new Error(error.message);
  return data as SetAcceptingTasksResult;
}

export function getCurrentPositionCoords(): Promise<{ lat: number; lng: number }> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation not supported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  });
}
